import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import GetINTouch from "../Contactus/GetINTouch";

export default function PaymentForm() {
  const [paymentMethod, setPaymentMethod] = useState("MasterCard");
  const [isVerified, setIsVerified] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(false);

  useEffect(() => {
    const tokenInput = document.getElementById("recaptcha-token");
    if (tokenInput && tokenInput.value) {
      setRecaptchaToken(tokenInput.value);
      setIsVerified(true);
    }
  }, []);

  const handleCaptcha = (token) => {
    if (token) {
      setRecaptchaToken(token);
      setIsVerified(true);
    } else {
      setRecaptchaToken("");
      setIsVerified(false);
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  return (
    <div className="pt-28 sm:pt-20 md:pt-24 lg:pt-[12.0625rem]">
      <form>
        <div className="px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12 lg:px-10 lg:py-16 block w-full mx-auto">
          <div className="flex flex-col justify-center items-center">
            <div className="text-center mb-32">
              <h1 className="text-white font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] lowercase tracking-[-.04em] leading-tight">
                Make A Payment
              </h1>
              <p className="text-white mt-6 max-w-2xl mx-auto text-lg sm:text-xl font-Matter">
                Please fill out the form below to securely complete your
                payment. Your information is protected and encrypted.
              </p>
            </div>

            <div className="grid md:grid-cols-2 grid-cols-1 xl:w-4/5 md:w-11/12 w-full gap-20">
              {/* Personal Details */}
              <div>
                <h3 className="text-[#cfa751] font-semibold mb-2 text-2xl tracking-wide font-Matter">
                  Personal Details
                </h3>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="firstName"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    First Name
                  </label>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="lastName"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Last Name
                  </label>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="email"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="email"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Email Address
                  </label>
                </div>
                {/* Payment Method */}
                <h3 className="text-[#cfa751] font-semibold mb-2 text-2xl tracking-wide font-Matter">
                  Payment Method
                </h3>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
                    {["MasterCard", "Visa", "Amex", "Discover"].map((card) => (
                      <button
                        key={card}
                        type="button"
                        onClick={() => setPaymentMethod(card)}
                        className={`py-2 rounded ${
                          paymentMethod === card
                            ? "bg-[#cfa751] text-white"
                            : "border border-[#cfa751] text-white"
                        }`}
                      >
                        {card}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="cardNumber"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Credit Card Number
                  </label>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <div className="flex gap-4">
                    <div className="relative z-0 w-2/3 group my-8 flex flex-col-reverse">
                      <input
                        type="text"
                        className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                        required
                      />
                      <label
                        htmlFor="expirationDate"
                        className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        Expiration Date
                      </label>
                    </div>
                    <div className="relative z-0 w-1/3 group my-8 flex flex-col-reverse">
                      <input
                        type="text"
                        className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                      />
                      <label
                        htmlFor="cvc"
                        className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                      >
                        CVC/CVV
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {/* Billing Information */}
              <div>
                <h3 className="text-[#cfa751] font-semibold mb-2 text-2xl tracking-wide font-Matter">
                  Billing Information
                </h3>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="paymentAmount"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Payment Amount
                  </label>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="invoiceNumber"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Invoice Number
                  </label>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                    required
                  />
                  <label
                    htmlFor="address"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Address
                  </label>
                </div>
                <div className="flex gap-4">
                  <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                    <input
                      type="text"
                      className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                      required
                    />
                    <label
                      htmlFor="city"
                      className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      City
                    </label>
                  </div>
                  <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                    <input
                      type="text"
                      className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                      required
                    />
                    <label
                      htmlFor="state"
                      className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      State
                    </label>
                  </div>
                  <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                    <input
                      type="text"
                      className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                      required
                    />
                    <label
                      htmlFor="zipCode"
                      className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                      Zip Code
                    </label>
                  </div>
                </div>
                <div className="relative z-0 w-full group my-8 flex flex-col-reverse">
                  <input
                    type="text"
                    className="pt-[1.2rem] pb-[1.2rem] tracking-[0.02em] text-[1.3rem] font-Matter text-white outline-none block bg-transparent border-b-[max(1px,_0.0625rem)] border-solid border-[#cfa751] w-full focus:outline-none focus:ring-0 focus:border-[#cfa751] peer"
                  />
                  <label
                    htmlFor="country"
                    className="peer-focus:font-semibold peer-focus:text-[1.3rem] absolute uppercase font-Matter text-[1rem] text-white tracking-[.2em] font-semibold duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#cfa751] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                  >
                    Country
                  </label>
                </div>
                {/* reCAPTCHA */}
                <div className=" flex justify-center items-center w-full  mb-4">
                  <div className="recaptcha-container ps-16 md:ps-0 w-full flex justify-center items-center ">
                    <ReCAPTCHA
                      sitekey="6LeeTGYrAAAAAA77ABJlfNMg9D_IUhmXT-yolFod"
                      onChange={handleCaptcha}
                      theme="dark"
                    />
                  </div>
                </div>
                {/* Pay Now Button */}
                {isVerified && (
                  <div className="md:col-span-2 text-center">
                    <button className="group relative inline-flex h-14 mt-6 items-center rounded-full px-16 font-semibold text-black bg-transparent overflow-hidden">
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>
                      <span className="relative">
                        <span className="flex flex-row gap-2 justify-center font-Matter tracking-wider items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          PAY NOW
                        </span>
                        <span className="absolute flex flex-row gap-2 top-0 font-Matter tracking-wider left-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          PAY NOW
                        </span>
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>{" "}
      </form>
      <GetINTouch />
    </div>
  );
}
